import React, { ReactNode } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

type Props = {
  accordionSummary: ReactNode;
  accordionDetails: ReactNode;
  expanded?: boolean;
  className?: string;
};

function Accordion({ accordionSummary, accordionDetails, expanded, className }: Props) {
  return (
    <MuiAccordion defaultExpanded={expanded != null ? expanded : false} className={className}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#F2F2F2' }}>
        {accordionSummary}
      </AccordionSummary>
      <AccordionDetails>{accordionDetails}</AccordionDetails>
    </MuiAccordion>
  );
}

export default Accordion;
